var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryRamen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_4756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 133.327C62.6176 133.327 51.2538 131.493 42.3529 128.437C43.6335 133.502 46.0394 137.333 49.0059 138.558C55.7012 141.326 64.8768 143.032 75 143.032C85.1232 143.032 94.2988 141.326 100.994 138.558C103.961 137.333 106.366 133.502 107.647 128.437C98.7462 131.493 87.3824 133.327 75 133.327Z",
    fill: "url(#paint0_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 70.8927C150 50.0468 -4.29153e-06 50.0468 -4.29153e-06 70.8927C-4.29153e-06 91.7386 17.6256 136.902 75 136.902C132.374 136.902 150 91.7386 150 70.8927Z",
    fill: "url(#paint1_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 70.8927C150 91.7386 -4.29153e-06 91.7386 -4.29153e-06 70.8927C-4.29153e-06 50.0468 150 50.0468 150 70.8927Z",
    fill: "url(#paint2_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 70.8927C143.806 86.2554 6.19353 86.2554 6.19353 70.8927C6.19353 55.5301 143.806 55.5301 143.806 70.8927Z",
    fill: "url(#paint3_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95235 74.4415C16.1459 78.7785 36.5235 81.3462 59.3271 82.1441C61.6179 82.2244 63.9329 80.2276 66.2618 80.2723C68.3391 80.312 70.4274 82.3962 72.5185 82.4076C101.945 82.5659 131.977 79.9103 141.047 74.4418C123.416 63.8115 26.5838 63.8115 8.95235 74.4415Z",
    fill: "url(#paint4_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3147 81.8995C1.92588 84.6604 2.76382 87.5677 3.85029 90.5454C24.8215 104.185 125.179 104.185 146.15 90.5454C147.236 87.5677 148.074 84.6604 148.685 81.8995C148.599 81.7968 148.514 81.6942 148.419 81.593C133.449 97.7063 16.5515 97.7063 1.58088 81.593C1.48676 81.6942 1.40088 81.7968 1.3147 81.8995Z",
    fill: "url(#paint5_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19353 96.2053C7.10029 98.1577 8.115 100.118 9.24765 102.068C36.0974 112.218 113.902 112.218 140.752 102.068C141.885 100.118 142.9 98.1577 143.806 96.2053C119.474 108.096 30.5256 108.096 6.19353 96.2053Z",
    fill: "url(#paint6_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.144 79.4077C109.556 81.5047 90.9429 82.5047 72.5627 82.408C70.6624 82.398 68.7644 80.3174 66.8747 80.2838C64.3456 80.2391 61.8312 82.2321 59.3459 82.1453C47.315 81.725 35.9582 80.8127 26.8559 79.408C30.5853 71.7727 36.75 65.2168 44.5206 60.4403C53.0912 55.1697 63.6206 52.0638 75 52.0638C86.3794 52.0638 96.9088 55.1697 105.479 60.4403C113.25 65.2165 119.415 71.7724 123.144 79.4077Z",
    fill: "url(#paint7_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.569 80.4083C111.289 73.1198 104.985 66.8433 97.2871 62.1112C92.3718 59.0886 86.8868 56.6962 80.9953 55.0721C70.4847 52.1748 59.2435 53.0471 49.4168 57.7695C47.7235 58.5833 46.0891 59.4754 44.5206 60.4398C36.75 65.2162 30.5853 71.7721 26.8559 79.4074C50.4524 83.0492 89.1965 83.3824 115.569 80.4083Z",
    fill: "url(#paint8_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.575 81.3368C101.305 74.3138 95.15 68.2565 87.6724 63.66C82.795 60.6606 77.3565 58.2821 71.5168 56.6588C62.44 54.1359 52.6847 55.4503 44.6462 60.3629C44.6041 60.3885 44.5623 60.4141 44.5206 60.44C36.75 65.2165 30.5853 71.7723 26.8559 79.4076C47.6171 82.6115 80.1047 83.2544 105.575 81.3368Z",
    fill: "url(#paint9_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2785 81.9568C91.0215 75.125 84.97 69.2279 77.6527 64.73C73.1209 61.9432 68.1044 59.6923 62.7318 58.0853C56.6374 56.2623 50.0291 57.0665 44.6044 60.3885C44.5765 60.4056 44.5485 60.4226 44.5209 60.44C36.7503 65.2165 30.5856 71.7723 26.8562 79.4076C35.9591 80.8123 47.3162 81.7247 59.3477 82.145C61.6282 82.2247 63.9332 80.8159 66.2515 80.8603C68.365 80.9006 70.4894 82.3968 72.6171 82.4079C80.2571 82.4468 87.9371 82.2965 95.2785 81.9568Z",
    fill: "url(#paint10_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3806 82.3179C80.2685 76.5485 74.8332 71.5388 68.4276 67.6015C63.5124 64.5788 58.0273 62.1865 52.1359 60.5623C51.8382 60.4803 51.4476 60.4209 51.0003 60.3791C46.9247 59.9979 42.8832 61.2912 39.6641 63.8194C34.1715 68.1335 29.77 73.4412 26.8556 79.4076C35.9541 80.8117 47.3047 81.7238 59.33 82.1441C61.5371 82.2212 63.7671 80.517 66.0097 80.5612C68.1988 80.6041 70.4006 82.3962 72.6053 82.4073C76.5374 82.4276 80.4794 82.3979 84.3806 82.3179Z",
    fill: "url(#paint11_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3853 82.413C70.6532 77.9754 66.0959 74.0754 60.8997 70.8812C55.9844 67.8586 50.4994 65.4662 44.6079 63.8421C44.5953 63.8386 44.5826 63.8351 44.57 63.8318C42.1612 63.1701 39.5865 63.8086 37.7035 65.4498C33.1206 69.4442 29.4138 74.1704 26.8559 79.4074C39.6926 81.3886 57.0129 82.3901 74.3853 82.413Z",
    fill: "url(#paint12_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1382 60.99C30.15 63.6165 23.5794 69.3724 20.0382 77.0488C19.8823 77.3871 19.7294 77.7282 19.5823 78.0694C21.6068 78.5138 23.8229 78.925 26.1965 79.3035C26.8782 77.1412 27.6965 75.0232 28.6518 72.9518C30.5547 68.8253 33.2871 65.2282 36.6253 62.3253C37.185 61.8382 37.7618 61.3712 38.3544 60.9238C38.2829 60.9465 38.2097 60.9665 38.1382 60.99Z",
    fill: "url(#paint13_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5382 53.6194C46.3294 54.5782 40.6735 57.243 36.1353 61.193C32.7971 64.0959 30.0647 67.693 28.1618 71.8194C27.0588 74.2106 26.1382 76.6635 25.4 79.1753C25.9412 79.2635 26.4882 79.3518 27.0471 79.4371C28.8706 79.7165 30.7823 79.9753 32.7706 80.2165C32.93 79.7191 33.0991 79.2253 33.275 78.7332C34.1279 75.5697 35.2685 72.4883 36.7029 69.505C38.0588 66.6815 39.8147 64.1021 41.8971 61.8168C45.1562 58.2385 49.2141 55.3841 53.7835 53.4532C53.3685 53.5015 52.9535 53.5553 52.5382 53.6194Z",
    fill: "url(#paint14_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2471 50.3771C53.2647 51.6142 46.15 55.4151 41.0147 60.9818C38.9324 63.238 37.1765 65.7848 35.8206 68.5724C34.0176 72.2748 32.6706 76.128 31.7882 80.1062C32.1118 80.1468 32.4412 80.1848 32.7706 80.2254C34.8206 80.4692 36.95 80.693 39.15 80.8933C39.9118 77.7339 41.0147 74.6674 42.45 71.7174C43.2682 70.0374 48.1341 62.6942 49.0585 61.5524C53.6971 55.8042 60.075 51.7515 67.2382 49.9436C65.2535 49.9268 63.2503 50.0671 61.2471 50.3771Z",
    fill: "url(#paint15_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5441 48.49C62.3147 48.7988 53.8441 53.0988 48.1971 60.1871C47.3529 61.243 46.5735 62.3636 45.8618 63.543C42.6412 68.8783 40.3941 74.6988 39.1529 80.893C41.5882 81.1224 44.1088 81.3224 46.6912 81.4988C47.2274 79.0583 47.9465 76.6891 48.8435 74.3994C49.3968 72.7985 50.02 71.2203 50.7206 69.6694C52.4382 65.8753 54.8265 62.5194 57.7235 59.7253C62.4441 55.1753 68.5206 52.1165 75.2412 51.0871C78.6035 50.5703 81.9647 50.588 85.2226 51.095C80.9868 49.2474 76.3303 48.3283 71.5441 48.49Z",
    fill: "url(#paint16_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6529 50.333C67.9324 51.3877 61.8559 54.5212 57.1353 59.1827C54.2382 62.0453 51.85 65.4832 50.1324 69.3703C48.4206 73.2512 47.1471 77.2921 46.3206 81.4624C46.4441 81.4715 46.5676 81.4803 46.6912 81.4894C48.8532 81.6424 51.0632 81.773 53.3065 81.8882C54.0838 79.0682 55.0953 76.3153 56.3356 73.6385C56.4962 73.2485 56.6618 72.8603 56.8324 72.4738C58.6324 68.3912 61.3974 64.9512 64.8068 62.4C65.8659 61.4941 66.9824 60.6503 68.1529 59.8777C72.2912 57.1527 77.0824 55.2897 82.2382 54.5027C87.4121 53.7135 92.5874 54.0468 97.4312 55.3909C90.7929 50.9253 82.725 49.0621 74.6529 50.333Z",
    fill: "url(#paint17_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.344 64.5518C112.047 63.1547 110.644 61.8812 109.159 60.74C101.644 54.9459 91.9382 52.4342 82.2382 53.943C77.0824 54.7459 72.2912 56.6459 68.1529 59.4253C63.2235 62.743 59.2235 67.3106 56.6559 72.7606C55.2647 75.7136 54.1471 78.7606 53.3029 81.8871C53.45 81.8959 53.5971 81.9047 53.7441 81.9106C55.3712 81.9903 57.0218 82.0565 58.6809 82.1162C63.9879 68.3018 76.7203 58.5694 91.5865 58.5694C100.23 58.5694 108.151 61.86 114.313 67.3289C114.387 66.3433 114.07 65.3318 113.344 64.5518Z",
    fill: "url(#paint18_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8635 56.1336C55.2735 55.0133 54.6976 53.7724 53.5773 53.3624C52.4571 52.9524 51.2162 53.5283 50.8062 54.6486C50.3962 55.7688 50.9721 57.0094 52.0923 57.4197C53.2129 57.8297 54.4535 57.2538 54.8635 56.1336Z",
    fill: "url(#paint19_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9562 57.9644C47.0718 57.6409 46.0924 58.0953 45.7685 58.98C45.4447 59.8644 45.8994 60.8438 46.7841 61.1676C47.6688 61.4914 48.6479 61.0367 48.9718 60.152C49.2953 59.2676 48.8406 58.2882 47.9562 57.9644Z",
    fill: "url(#paint20_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4173 62.1356C53.8841 61.9406 53.2935 62.2147 53.0985 62.7479C52.9032 63.2812 53.1774 63.8718 53.7106 64.0668C54.2438 64.2618 54.8344 63.9879 55.0294 63.4547C55.2247 62.9212 54.9506 62.3309 54.4173 62.1356Z",
    fill: "url(#paint21_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8597 58.6885C62.6738 58.8179 61.8174 59.8844 61.9468 61.0705C62.0762 62.2564 63.1426 63.1129 64.3288 62.9835C65.5147 62.8541 66.3712 61.7876 66.2418 60.6014C66.1123 59.4152 65.0459 58.5591 63.8597 58.6885Z",
    fill: "url(#paint22_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.955 52.975C66.0188 53.0773 65.3426 53.9191 65.4447 54.8556C65.5471 55.7917 66.3888 56.4679 67.3253 56.3658C68.2615 56.2635 68.9376 55.4217 68.8356 54.4853C68.7332 53.5488 67.8912 52.8726 66.955 52.975Z",
    fill: "url(#paint23_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4609 53.4492C58.8965 53.5109 58.4888 54.0183 58.5503 54.583C58.6121 55.1474 59.1194 55.5551 59.6841 55.4936C60.2485 55.4318 60.6562 54.9245 60.5947 54.3598C60.5332 53.7951 60.0253 53.3874 59.4609 53.4492Z",
    fill: "url(#paint24_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.31 62.6868C56.4853 62.998 56.0688 63.9192 56.3803 64.7439C56.6915 65.5686 57.6126 65.9851 58.4373 65.6736C59.2621 65.3624 59.6785 64.4412 59.3671 63.6165C59.0556 62.7918 58.1347 62.3754 57.31 62.6868Z",
    fill: "url(#paint25_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4715 58.0276C57.8203 58.2735 57.4918 59.0005 57.7374 59.6517C57.9832 60.3029 58.7103 60.6314 59.3615 60.3858C60.0126 60.14 60.3412 59.4129 60.0956 58.7617C59.8497 58.1105 59.1226 57.7817 58.4715 58.0276Z",
    fill: "url(#paint26_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7329 61.17C54.1256 61.0218 54.3235 60.5836 54.1756 60.1909C54.0274 59.7983 53.5891 59.6003 53.1965 59.7483C52.8038 59.8965 52.6059 60.3347 52.7538 60.7274C52.9021 61.12 53.3406 61.3183 53.7329 61.17Z",
    fill: "url(#paint27_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5891 55.4382C78.9991 54.318 78.4232 53.0771 77.3029 52.6671C76.1826 52.2571 74.9418 52.833 74.5318 53.9532C74.1218 55.0735 74.6977 56.3144 75.8179 56.7244C76.9382 57.1347 78.1788 56.5588 78.5891 55.4382Z",
    fill: "url(#paint28_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6818 57.2691C70.7974 56.9455 69.8179 57.4 69.4941 58.2847C69.1703 59.1694 69.625 60.1485 70.5094 60.4723C71.3938 60.7961 72.3732 60.3414 72.6971 59.4567C73.0209 58.5723 72.5662 57.5929 71.6818 57.2691Z",
    fill: "url(#paint29_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1429 61.4405C77.6097 61.2452 77.0191 61.5194 76.8241 62.0529C76.6288 62.5861 76.9029 63.1767 77.4362 63.3717C77.9694 63.567 78.56 63.2929 78.755 62.7597C78.9503 62.2261 78.6762 61.6355 78.1429 61.4405Z",
    fill: "url(#paint30_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6424 56.7189C89.4565 56.8483 88.6 57.9147 88.7294 59.1009C88.8588 60.2868 89.9253 61.1433 91.1115 61.0139C92.2974 60.8845 93.1538 59.818 93.0244 58.6318C92.895 57.4459 91.8285 56.5895 90.6424 56.7189Z",
    fill: "url(#paint31_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0118 53.895C89.9094 52.9588 89.0677 52.2826 88.1312 52.385C87.1947 52.4874 86.5188 53.3291 86.6209 54.2653C86.7232 55.2018 87.565 55.8776 88.5015 55.7756C89.4379 55.6732 90.1141 54.8312 90.0118 53.895Z",
    fill: "url(#paint32_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1865 52.7538C82.6221 52.8156 82.2144 53.3229 82.2759 53.8876C82.3376 54.452 82.845 54.8597 83.4097 54.7979C83.9741 54.7362 84.3818 54.2285 84.3203 53.6641C84.2585 53.1 83.7509 52.6923 83.1865 52.7538Z",
    fill: "url(#paint33_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0356 61.9915C80.2109 62.3027 79.7944 63.2239 80.1059 64.0486C80.4171 64.8733 81.3382 65.2898 82.1629 64.9783C82.9877 64.6671 83.4041 63.7459 83.0927 62.9212C82.7812 62.0965 81.8603 61.6803 81.0356 61.9915Z",
    fill: "url(#paint34_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1971 57.3323C81.5459 57.5782 81.2173 58.3052 81.4629 58.9561C81.7088 59.6073 82.4359 59.9358 83.0871 59.6902C83.7382 59.4444 84.0668 58.7173 83.8212 58.0664C83.5753 57.4152 82.8482 57.0867 82.1971 57.3323Z",
    fill: "url(#paint35_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4585 60.4747C77.8512 60.3265 78.0491 59.8883 77.9012 59.4956C77.7529 59.103 77.3147 58.905 76.9221 59.053C76.5294 59.2012 76.3315 59.6394 76.4794 60.0321C76.6276 60.425 77.0659 60.623 77.4585 60.4747Z",
    fill: "url(#paint36_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8979 51.765C72.6282 52.0324 73.4368 51.6568 73.7041 50.9268C73.9715 50.1965 73.5962 49.388 72.8659 49.1206C72.1356 48.8533 71.3271 49.2286 71.0597 49.9589C70.7923 50.6895 71.1676 51.498 71.8979 51.765Z",
    fill: "url(#paint37_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8488 51.7683C64.9759 51.4207 64.7974 51.036 64.4497 50.9086C64.1021 50.7816 63.7174 50.9601 63.5903 51.3077C63.4632 51.6554 63.6418 52.0401 63.9894 52.1674C64.3368 52.2945 64.7215 52.116 64.8488 51.7683Z",
    fill: "url(#paint38_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0215 54.6777C72.9812 54.3098 72.6506 54.0442 72.2827 54.0842C71.9147 54.1245 71.6491 54.4551 71.6894 54.823C71.7297 55.191 72.0603 55.4565 72.4282 55.4165C72.7959 55.3763 73.0618 55.0457 73.0215 54.6777Z",
    fill: "url(#paint39_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3388 51.3207C81.2985 50.9527 80.9679 50.6871 80.6 50.7271C80.2321 50.7674 79.9665 51.098 80.0068 51.466C80.0471 51.8339 80.3779 52.0995 80.7456 52.0595C81.1132 52.0192 81.3788 51.6886 81.3388 51.3207Z",
    fill: "url(#paint40_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4897 53.6536C64.2868 53.1159 63.6865 52.8447 63.1488 53.0477C62.6112 53.2506 62.34 53.8509 62.5429 54.3883C62.7459 54.9259 63.3462 55.1971 63.8835 54.9942C64.4212 54.7915 64.6927 54.1912 64.4897 53.6536Z",
    fill: "url(#paint41_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3365 50.7397C69.1762 50.3153 68.7024 50.1012 68.2779 50.2612C67.8535 50.4215 67.6394 50.8953 67.7994 51.3197C67.9597 51.7441 68.4335 51.9582 68.8579 51.7979C69.2827 51.6379 69.4968 51.1641 69.3365 50.7397Z",
    fill: "url(#paint42_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1988 50.7397C77.0385 50.3153 76.5647 50.1012 76.1403 50.2612C75.7159 50.4215 75.5018 50.8953 75.6621 51.3197C75.8224 51.7441 76.2962 51.9582 76.7206 51.7979C77.1447 51.6379 77.3588 51.1641 77.1988 50.7397Z",
    fill: "url(#paint43_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6062 53.1395C69.7026 53.3953 69.9885 53.5245 70.2444 53.428C70.5003 53.3315 70.6294 53.0456 70.5329 52.7898C70.4365 52.5339 70.1506 52.4047 69.8947 52.5012C69.6385 52.598 69.5094 52.8839 69.6062 53.1395Z",
    fill: "url(#paint44_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1341 72.14C71.6474 71.5265 70.8565 71.1639 69.9971 71.2897H69.9941C69.8824 71.3074 69.7706 71.3133 69.6588 71.3133C69.2062 71.3133 68.7656 71.1783 68.3918 70.9312C68.3138 70.8492 67.9035 70.438 67.7668 70.33C67.3059 69.7521 66.6391 69.4603 65.9706 69.4603C65.2765 69.4603 64.5824 69.7692 64.1235 70.3868C63.6176 71.0662 62.7794 71.4133 61.9441 71.2897H61.9412C60.4147 71.0662 59.1059 72.378 59.3294 73.9015V73.9044C59.3471 74.0162 59.3529 74.128 59.3529 74.2397C59.3529 74.9574 59.0147 75.6456 58.4265 76.0839C57.8088 76.5456 57.5 77.2368 57.5 77.928C57.5 78.5986 57.7912 79.2674 58.3679 79.7259C58.4206 79.793 58.7094 79.8074 58.8315 79.9324C58.9591 80.0633 58.9194 80.3041 58.9597 80.3424C59.2732 80.8097 59.4144 81.3815 59.3294 81.9544V81.9574C59.3206 82.0212 59.315 82.0821 59.3121 82.1433C61.47 82.2188 63.6497 80.808 65.8418 80.8518C68.0806 80.8965 70.3324 82.3956 72.5877 82.4071C75.8438 82.4241 79.1077 82.4065 82.3491 82.3547L72.1341 72.14Z",
    fill: "url(#paint45_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4382 77.9282C74.4382 78.6223 74.1294 79.3165 73.5118 79.7753C72.8324 80.2812 72.4853 81.1194 72.6088 81.9547V81.9576C72.6324 82.1106 72.6382 82.2606 72.6294 82.4076C70.35 82.3988 68.0735 82.3694 65.8118 82.3253C64.5618 82.2988 63.3176 82.2694 62.0794 82.2341C61.1529 82.2076 60.2294 82.1782 59.3118 82.1459C59.3147 82.0841 59.3206 82.0223 59.3294 81.9576V81.9547C59.4529 81.1194 59.1059 80.2812 58.4265 79.7753C57.8088 79.3165 57.5 78.6223 57.5 77.9282C57.5 77.237 57.8088 76.5459 58.4265 76.0841C59.0147 75.6459 59.3529 74.9576 59.3529 74.24C59.3529 74.1282 59.3471 74.0165 59.3294 73.9047V73.9018C59.1059 72.3782 60.4147 71.0665 61.9412 71.29H61.9441C62.7794 71.4135 63.6176 71.0665 64.1235 70.387C64.5824 69.7694 65.2765 69.4606 65.9706 69.4606C66.6618 69.4606 67.3529 69.7694 67.8147 70.387C68.2529 70.9753 68.9412 71.3135 69.6588 71.3135C69.7706 71.3135 69.8824 71.3076 69.9941 71.29H69.9971C71.5206 71.0665 72.8294 72.3782 72.6088 73.9018V73.9047C72.4853 74.74 72.8324 75.5782 73.5118 76.0841C74.1294 76.5459 74.4382 77.237 74.4382 77.9282Z",
    fill: "url(#paint46_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9559 77.2664C70.8206 78.3341 70.2765 79.2812 69.4294 79.94C68.5794 80.5959 67.5265 80.8841 66.4618 80.7488C65.5529 80.6341 64.7471 80.1723 64.1882 79.4488C63.6265 78.7253 63.3824 77.8282 63.4971 76.9223C63.5706 76.3576 64.0853 75.9606 64.65 76.0312C65.2118 76.1017 65.6118 76.6194 65.5412 77.1812C65.4941 77.5429 65.5912 77.8988 65.8147 78.187C66.0382 78.4753 66.3588 78.6606 66.7206 78.7047C67.2412 78.7723 67.7529 78.6312 68.1676 78.3106C68.5824 77.99 68.8471 77.5282 68.9118 77.0076C69.1 75.5282 68.05 74.1694 66.5676 73.9812C65.6029 73.8576 64.6471 74.1194 63.8794 74.7135C63.1088 75.3106 62.6176 76.1694 62.4941 77.1341C62.2 79.4723 63.6412 81.637 65.8118 82.3253C64.5618 82.2988 63.3176 82.2694 62.0794 82.2341C61.4706 81.5341 61.0059 80.7106 60.7206 79.8194C60.4265 78.8988 60.3235 77.8988 60.4529 76.8753C60.85 73.7547 63.7088 71.54 66.8265 71.937C69.4353 72.2694 71.2853 74.6606 70.9559 77.2664Z",
    fill: "url(#paint47_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.284 81.0348L86.9597 58.71C86.5391 58.0489 85.5988 57.6147 84.5571 57.7321L84.555 57.7324C83.7179 57.8268 82.8809 57.5594 82.3756 57.0365C81.455 56.0839 79.6032 56.0839 78.6826 57.0365C78.1774 57.5594 77.3403 57.8265 76.5032 57.7324L76.5012 57.7321C74.9765 57.5603 73.6673 58.5692 73.89 59.7442L73.8903 59.7456C74.0126 60.3906 73.6659 61.0356 72.9873 61.425C71.8015 62.1056 71.7565 63.4444 72.8456 64.1789L73.5512 64.9121C73.815 65.1862 73.9603 65.5683 73.8918 65.9424C73.8912 65.945 73.8909 65.9477 73.8903 65.9503L73.89 65.9518C73.7703 66.5824 74.0944 67.163 74.6535 67.5412L89.3021 82.1898C96.2691 81.9683 103.03 81.5833 109.284 81.0348Z",
    fill: "url(#paint48_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0706 64.2706C87.3921 64.66 87.0453 65.305 87.1676 65.95L87.1679 65.9515C87.3909 67.1265 86.0818 68.1353 84.5568 67.9636L84.5547 67.9633C83.7176 67.8689 82.8806 68.1362 82.3753 68.6592C81.4547 69.6118 79.6029 69.6118 78.6823 68.6592C78.1771 68.1362 77.34 67.8692 76.5029 67.9633L76.5009 67.9636C74.9762 68.1353 73.6671 67.1265 73.89 65.9515L73.8903 65.95C74.0126 65.305 73.6659 64.66 72.9874 64.2706C71.7512 63.5612 71.7512 62.1344 72.9874 61.425C73.6659 61.0356 74.0126 60.3906 73.8903 59.7456L73.89 59.7442C73.6671 58.5692 74.9762 57.5603 76.5012 57.7321L76.5032 57.7324C77.3403 57.8268 78.1774 57.5594 78.6826 57.0365C79.6032 56.0839 81.455 56.0839 82.3756 57.0365C82.8809 57.5594 83.7179 57.8265 84.555 57.7324L84.5571 57.7321C86.0818 57.5603 87.3909 58.5692 87.1679 59.7442L87.1676 59.7456C87.0453 60.3906 87.3921 61.0356 88.0706 61.425C89.3068 62.1344 89.3068 63.5612 88.0706 64.2706Z",
    fill: "url(#paint49_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2806 64.3048C74.9856 63.5933 74.8826 62.823 75.0126 62.0345C75.4091 59.6315 78.2688 57.9248 81.3871 58.2303C83.9944 58.4859 85.8459 60.3283 85.5147 62.3374C85.3794 63.158 84.8374 63.8889 83.9885 64.3953C83.1397 64.9018 82.0859 65.1236 81.0206 65.0192C80.1141 64.9304 79.3065 64.5748 78.7471 64.018C78.1874 63.4612 77.9427 62.7698 78.0582 62.0712C78.13 61.6365 78.6453 61.3292 79.2091 61.3845C79.7732 61.4398 80.1721 61.8368 80.1003 62.2715C80.0544 62.5498 80.1518 62.8248 80.3747 63.0468C80.5974 63.2686 80.9191 63.4101 81.2803 63.4454C81.7997 63.4962 82.3138 63.3883 82.7279 63.1412C83.1418 62.8942 83.4062 62.5377 83.4724 62.1374C83.6609 60.9959 82.6088 59.9489 81.1277 59.8042C80.1627 59.7095 79.2074 59.9103 78.4382 60.3695C77.6691 60.8286 77.1779 61.4909 77.0553 62.2348C76.7206 64.2621 78.5894 66.1215 81.2206 66.3792C81.7844 66.4345 82.1838 66.8309 82.1121 67.2662C82.0403 67.7009 81.525 68.0083 80.9609 67.953C78.2265 67.6853 76.0688 66.2062 75.2806 64.3048Z",
    fill: "url(#paint50_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1088 81.4691C66.4809 81.4309 62.8718 82.2676 59.3215 82.1435C55.5235 82.0106 51.7929 81.8285 48.1794 81.5959L39.6382 73.0547C39.0794 72.6782 38.7559 72.0959 38.8765 71.4665V71.4635C38.8765 71.4635 38.8765 71.4606 38.8765 71.4576C38.9471 71.0841 38.8 70.7017 38.5353 70.4253L37.8294 69.6929C37.3088 69.34 37.0471 68.8488 37.0471 68.3606C37.0471 67.8282 37.3559 67.2929 37.9735 66.94C38.65 66.5488 38.9971 65.9047 38.8765 65.2606V65.2576C38.8147 64.9282 38.8706 64.6106 39.0235 64.3312C39.25 63.9017 39.6912 63.5576 40.2412 63.3753C40.6176 63.2459 41.0412 63.1959 41.4853 63.2459H41.4882C42.3265 63.34 43.1618 63.0753 43.6676 62.5517C44.1294 62.0753 44.8206 61.837 45.5147 61.837C46.2088 61.837 46.9 62.0753 47.3618 62.5517C47.7971 63.0047 48.4853 63.2635 49.2059 63.2635C49.3176 63.2635 49.4294 63.2576 49.5412 63.2459C50.5853 63.1282 51.5235 63.5635 51.9441 64.2253L70.1088 81.4691Z",
    fill: "url(#paint51_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0559 69.7853C52.3773 70.1747 52.0306 70.8197 52.1529 71.4647L52.1532 71.4661C52.3762 72.6411 51.0671 73.65 49.5421 73.4782L49.54 73.4779C48.7029 73.3835 47.8659 73.6509 47.3606 74.1738C46.44 75.1264 44.5882 75.1264 43.6676 74.1738C43.1623 73.6509 42.3253 73.3838 41.4882 73.4779L41.4862 73.4782C39.9615 73.65 38.6523 72.6411 38.8753 71.4661L38.8756 71.4647C38.9979 70.8197 38.6512 70.1747 37.9726 69.7853C36.7365 69.0759 36.7365 67.6491 37.9726 66.9397C38.6512 66.5503 38.9979 65.9053 38.8756 65.2603L38.8753 65.2588C38.6523 64.0838 39.9615 63.075 41.4865 63.2467L41.4885 63.247C42.3256 63.3414 43.1626 63.0741 43.6679 62.5512C44.5885 61.5985 46.4403 61.5985 47.3609 62.5512C47.8662 63.0741 48.7029 63.3412 49.5403 63.247L49.5423 63.2467C51.0671 63.075 52.3762 64.0838 52.1532 65.2588L52.1529 65.2603C52.0306 65.9053 52.3773 66.5503 53.0559 66.9397C54.2921 67.6491 54.2921 69.0759 53.0559 69.7853Z",
    fill: "url(#paint52_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2659 69.8194C39.9709 69.1079 39.8679 68.3376 39.9979 67.5491C40.3944 65.1462 43.2541 63.4394 46.3723 63.745C48.9797 64.0006 50.8312 65.8429 50.5 67.8521C50.3647 68.6726 49.8226 69.4035 48.9738 69.91C48.125 70.4165 47.0712 70.6382 46.0059 70.5338C45.0994 70.445 44.2918 70.0894 43.7323 69.5326C43.1726 68.9759 42.9279 68.2844 43.0435 67.5859C43.1153 67.1512 43.6306 66.8438 44.1944 66.8991C44.7585 66.9544 45.1573 67.3515 45.0856 67.7862C45.0397 68.0644 45.1371 68.3394 45.36 68.5615C45.5826 68.7832 45.9044 68.9247 46.2656 68.96C46.785 69.0109 47.2991 68.9029 47.7132 68.6559C48.1271 68.4088 48.3915 68.0524 48.4576 67.6521C48.6462 66.5106 47.5941 65.4635 46.1129 65.3188C45.1479 65.2241 44.1926 65.425 43.4235 65.8841C42.6544 66.3432 42.1632 67.0056 42.0406 67.7494C41.7059 69.7768 43.5747 71.6362 46.2059 71.8938C46.7697 71.9491 47.1691 72.3456 47.0973 72.7809C47.0256 73.2156 46.5103 73.5229 45.9462 73.4676C43.2118 73.2 41.0541 71.7209 40.2659 69.8194Z",
    fill: "url(#paint53_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.935 31.4751C102.582 30.5812 103.553 29.7451 104.389 30.2204C107.341 31.8989 111.674 35.353 111.674 41.1659C111.674 49.9809 101.056 50.8121 101.056 57.3415C101.056 60.6924 101.499 63.0065 101.931 64.4654C102.181 65.3092 101.318 66.0527 100.523 65.6765C97.8771 64.4251 93.8079 61.3712 93.8079 54.4256C93.8079 44.1348 104.338 44.2877 104.338 38.6612C104.338 35.7227 103.621 33.2077 102.935 31.4751Z",
    fill: "url(#paint54_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6876 7.53768C76.4571 7.14415 77.0741 6.78532 77.4876 7.0712C80.2924 9.01062 85.0356 13.1112 85.0356 18.6586C85.0356 26.5344 76.0585 28.7641 74.8624 34.9059C73.8947 39.8739 76.1124 44.71 77.1291 46.5886C77.3056 46.9144 76.8994 47.245 76.4788 47.1192C73.3856 46.1927 65.0641 42.76 66.3068 32.87C67.5106 23.2891 76.5156 23.7268 78.1135 17.528C79.2618 13.0774 77.8471 9.51621 76.6876 7.53768Z",
    fill: "url(#paint55_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1918 33.5691C52.8765 32.8318 53.5371 32.1418 54.18 32.5338C56.4512 33.9188 59.8471 36.7691 60.2103 41.5656C60.7612 48.8394 53.0206 49.5253 53.4288 54.9132C53.6382 57.6782 54.1085 59.5877 54.5168 60.7918C54.7529 61.4879 54.1659 62.1018 53.5585 61.7912C51.5388 60.7585 48.3618 58.2385 47.9276 52.5074C47.2844 44.0156 55.0218 44.1418 54.67 39.4988C54.4865 37.0741 53.8029 34.9985 53.1918 33.5691Z",
    fill: "url(#paint56_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 70.8941C150 79.5941 123.859 84.6647 93.4029 86.1L102.297 81.5677C125.529 80.05 143.806 76.4912 143.806 70.8941C143.806 68.5294 140.544 66.5265 135.024 64.8912L139.724 62.4941C146.162 64.7618 150 67.5618 150 70.8941Z",
    fill: "url(#paint57_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.866 55.5815L78.7603 89.9077C77.9985 90.4342 78.6538 91.6927 79.9447 92.1833C80.5385 92.4089 81.1241 92.4048 81.4862 92.1721L144.981 59.0001C146.445 58.0601 144.679 55.6018 142.332 55.3127C141.742 55.2398 141.222 55.3351 140.866 55.5815Z",
    fill: "url(#paint58_linear_465_4756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.351 56.8263L82.0365 91.1524C81.2747 91.6789 81.93 92.9374 83.2209 93.428C83.8147 93.6536 84.4003 93.6495 84.7624 93.4169L149.466 60.2448C150.93 59.3048 149.164 56.8466 146.817 56.5574C146.227 56.4848 145.707 56.5801 145.351 56.8263Z",
    fill: "url(#paint59_linear_465_4756)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_4756",
    x1: 75.3088,
    y1: 133.531,
    x2: 75.8579,
    y2: 142.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_4756",
    x1: 63.6194,
    y1: 62.0877,
    x2: 106.855,
    y2: 126.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_4756",
    x1: 65.8888,
    y1: 34.1104,
    x2: 76.477,
    y2: 76.8554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_4756",
    x1: 75,
    y1: 100.334,
    x2: 75,
    y2: -6.02315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_4756",
    x1: 75,
    y1: 67.0988,
    x2: 75,
    y2: 77.5565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_4756",
    x1: 100.645,
    y1: 102.41,
    x2: 112.998,
    y2: 110.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_4756",
    x1: 98.4129,
    y1: 113.727,
    x2: 109.771,
    y2: 121.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_4756",
    x1: 65.5726,
    y1: 56.4474,
    x2: 77.7294,
    y2: 86.0553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_4756",
    x1: 72.2674,
    y1: 73.5056,
    x2: 85.2085,
    y2: -5.02376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_4756",
    x1: 66.6768,
    y1: 84.3923,
    x2: 58.7618,
    y2: 15.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_4756",
    x1: 61.5103,
    y1: 78.1806,
    x2: 72.6868,
    y2: 15.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_4756",
    x1: 57.7874,
    y1: 74.5126,
    x2: 67.9344,
    y2: 44.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_4756",
    x1: 50.7253,
    y1: 82.6371,
    x2: 49.1568,
    y2: 56.7548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_4756",
    x1: 27.1741,
    y1: 67.1812,
    x2: 30.2132,
    y2: 71.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_4756",
    x1: 33.4912,
    y1: 60.7059,
    x2: 39.5697,
    y2: 66.2941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_4756",
    x1: 42.3618,
    y1: 57.3695,
    x2: 49.3224,
    y2: 64.8204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_4756",
    x1: 51.1373,
    y1: 51.9136,
    x2: 60.255,
    y2: 63.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_4756",
    x1: 56.0979,
    y1: 46.9112,
    x2: 69.0391,
    y2: 64.5582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_4756",
    x1: 70.7727,
    y1: 52.2233,
    x2: 78.4197,
    y2: 64.9686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_4756",
    x1: 50.9109,
    y1: 52.7239,
    x2: 56.8926,
    y2: 61.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_4756",
    x1: 45.8512,
    y1: 57.4603,
    x2: 50.5735,
    y2: 64.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_4756",
    x1: 53.1482,
    y1: 61.8318,
    x2: 55.9953,
    y2: 65.7788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_4756",
    x1: 62.1703,
    y1: 58.1685,
    x2: 68.1523,
    y2: 66.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_4756",
    x1: 65.6212,
    y1: 52.5644,
    x2: 70.3438,
    y2: 59.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_4756",
    x1: 58.6568,
    y1: 53.2018,
    x2: 61.5041,
    y2: 57.1489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_4756",
    x1: 56.4518,
    y1: 62.2089,
    x2: 60.8726,
    y2: 68.3377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_4756",
    x1: 57.7941,
    y1: 57.6503,
    x2: 61.2841,
    y2: 62.4888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_4756",
    x1: 52.7879,
    y1: 59.5209,
    x2: 54.8921,
    y2: 62.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_4756",
    x1: 74.6365,
    y1: 52.0285,
    x2: 80.6182,
    y2: 60.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_4756",
    x1: 69.5768,
    y1: 56.765,
    x2: 74.2991,
    y2: 63.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_465_4756",
    x1: 76.8738,
    y1: 61.1364,
    x2: 79.7209,
    y2: 65.0835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_4756",
    x1: 88.9529,
    y1: 56.1989,
    x2: 94.935,
    y2: 64.4924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_4756",
    x1: 86.7976,
    y1: 51.9744,
    x2: 91.5203,
    y2: 58.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_4756",
    x1: 82.3824,
    y1: 52.5065,
    x2: 85.2294,
    y2: 56.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_4756",
    x1: 80.1774,
    y1: 61.5136,
    x2: 84.5979,
    y2: 67.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_4756",
    x1: 81.5197,
    y1: 56.9552,
    x2: 85.0094,
    y2: 61.7935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_4756",
    x1: 76.5135,
    y1: 58.8259,
    x2: 78.6176,
    y2: 61.7427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_4756",
    x1: 74.1203,
    y1: 49.1892,
    x2: 68.7156,
    y2: 53.0877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_4756",
    x1: 65.0471,
    y1: 50.9413,
    x2: 62.4747,
    y2: 52.7968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_4756",
    x1: 73.1829,
    y1: 54.1536,
    x2: 70.6103,
    y2: 56.0092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_4756",
    x1: 81.5003,
    y1: 50.7965,
    x2: 78.9276,
    y2: 52.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_4756",
    x1: 64.8012,
    y1: 53.0942,
    x2: 60.8068,
    y2: 55.9756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_4756",
    x1: 69.5827,
    y1: 50.2982,
    x2: 66.4291,
    y2: 52.5727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_4756",
    x1: 77.4447,
    y1: 50.2982,
    x2: 74.2915,
    y2: 52.5726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_465_4756",
    x1: 70.6809,
    y1: 52.5239,
    x2: 68.7797,
    y2: 53.8951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_4756",
    x1: 82.265,
    y1: 86.9983,
    x2: 55.3532,
    y2: 70.8218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_4756",
    x1: 61.2103,
    y1: 72.2929,
    x2: 69.5285,
    y2: 81.2226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_4756",
    x1: 60.3979,
    y1: 77.1079,
    x2: 70.9938,
    y2: 77.1079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3566,
    stopColor: "#FB9D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#FF849B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF819C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_4756",
    x1: 93.0665,
    y1: 75.8383,
    x2: 69.6841,
    y2: 44.8089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_4756",
    x1: 76.1256,
    y1: 58.1206,
    x2: 83.7556,
    y2: 66.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_4756",
    x1: 77.662,
    y1: 58.8645,
    x2: 83.5918,
    y2: 66.5286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3566,
    stopColor: "#FB9D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#FF849B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF819C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_465_4756",
    x1: 55.4015,
    y1: 78.0565,
    x2: 35.9417,
    y2: 52.2326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_465_4756",
    x1: 41.1109,
    y1: 63.6353,
    x2: 48.7409,
    y2: 71.8264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_465_4756",
    x1: 42.6409,
    y1: 64.3637,
    x2: 48.5706,
    y2: 72.0278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3566,
    stopColor: "#FB9D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#FF849B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF819C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_465_4756",
    x1: 97.3365,
    y1: 45.5104,
    x2: 121.748,
    y2: 57.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_465_4756",
    x1: 68.4997,
    y1: 25.0794,
    x2: 86.8503,
    y2: 29.3971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1575,
    stopColor: "#E97869",
    stopOpacity: 0.158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3778,
    stopColor: "#EC8B78",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#F0A991",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9188,
    stopColor: "#F6D2B3",
    stopOpacity: 0.919
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_465_4756",
    x1: 48.3797,
    y1: 45.0182,
    x2: 61.7129,
    y2: 50.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_465_4756",
    x1: 123.92,
    y1: 82.4809,
    x2: 118.332,
    y2: 71.1574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_465_4756",
    x1: 110.967,
    y1: 72.5874,
    x2: 112.732,
    y2: 75.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_465_4756",
    x1: 114.386,
    y1: 73.1042,
    x2: 117.328,
    y2: 77.8101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_4756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryRamen);
export default __webpack_public_path__ + "static/media/icon-category-ramen.45e55225.svg";
export { ForwardRef as ReactComponent };